import React, { useEffect } from "react";
import logo from "../../assets/icons/mocionYellow.svg";
import bglogo from "../../assets/images/final.png";
import closeIcon from "../../assets/icons/deletewhite.svg";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import {
  useGetLeagueLeaderBoardTeamsQuery,
  useGetTournamentLeaderBoardTeamsQuery,
} from "../../lib/redux/services/sections/Leagues-Tournaments";
import Table from "../../components/custom/tableWrapper/Table";
import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import Loader from "../../components/skeletons/Loader";
import { useSocket } from "../../components/providers/SocketProvider";
const Leaderboard = () => {
  const { socket, subscribe, unsubscribe } = useSocket();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { leagues_tournaments }: DictionaryType = useGetDictionary();
  const teamsApi =
    searchParams.get("type") == "leagues"
      ? useGetLeagueLeaderBoardTeamsQuery
      : useGetTournamentLeaderBoardTeamsQuery;

  const { data, isFetching, isLoading, refetch } = teamsApi(id);
  console.log(data);

  useEffect(() => {
    const handleMessage = (data: any) => {
      console.log(data);
      console.log("hello");
      // Handle specific message types
      if (data[0].message.type === "mail.channel/new_message") {
        refetch();
      }
    };

    subscribe(handleMessage);

    return () => {
      unsubscribe(handleMessage);
    };
  }, [subscribe, unsubscribe, refetch, socket]);

  const columns = [
    { title: leagues_tournaments.leaderboard_table.Team, tag: "team_name" },
    {
      title: leagues_tournaments.leaderboard_table.total_score,
      tag: "total_score",
    },
    {
      title: leagues_tournaments.leaderboard_table.played_matches,
      tag: "played_matches",
    },
    { title: leagues_tournaments.leaderboard_table.win, tag: "win" },
    { title: leagues_tournaments.leaderboard_table.lose, tag: "lose" },
    { title: leagues_tournaments.leaderboard_table.tie, tag: "tie" },
    {
      title: leagues_tournaments.leaderboard_table.points_for,
      tag: "point_for",
    },
    {
      title: leagues_tournaments.leaderboard_table.points_against,
      tag: "point_against",
    },
  ];

  const config = {
    // win: {
    //   columnCellClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   tdClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   customClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    // },
    // lose: {
    //   columnCellClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   tdClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   customClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    // },
    // tie: {
    //   columnCellClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   tdClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    //   customClassName: "!w-[40px] !min-w-[40px] !max-w-[40px]",
    // },
    // point_for: {
    //   columnCellClassName: "!w-[120px] !min-w-[120px] !max-w-[120px]",
    //   tdClassName: "!w-[120px] !min-w-[120px] !max-w-[120px]",
    //   customClassName: "!w-[120px] !min-w-[120px] !max-w-[120px]",
    // },
    // total_score: {
    //   columnCellClassName: "!w-[100px] !min-w-[100px] !max-w-[100px]",
    //   tdClassName: "!w-[100px] !min-w-[100px] !max-w-[100px]",
    //   customClassName: "!w-[100px] !min-w-[100px] !max-w-[100px]",
    // },
  };
  let colorIndex = 100;

  return (
    <div
      style={{
        backgroundImage: `url(${bglogo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}
      className="w-full h-dvh flex flex-col  bg-white overflow-y-auto customScroll pb-5"
    >
      <div className="bg-primary h-[8vh]">
        <div className=" relative flex flex-row justify-center items-center pt-3">
          <img loading="lazy" src={logo} alt="logo" />
        </div>
      </div>
      <div className=" flex flex-row justify-around items-center text-primary dark:text-white text-4xl font-bold pt-5">
        <p>{searchParams.get("club")}</p>
        <h1>{searchParams.get("name")}</h1>
      </div>
      {isLoading ? (
        <Loader />
      ) : searchParams.get("tournamentType") == "Knockouts" ? (
        <div className="grid grid-cols-1">
          <div className="px-4 mt-10">
            <div className="fixed-table  bg-transparent ">
              <Table
                tableClassName="mt-0 rounded-t-none "
                generalCellColumnClassName=""
                tbodyClassName=" !bg-transparent rounded-none !max-h-[70vh]  "
                generalCellRowClassName="min-w-[150px] text-base overflow-hidden text-left  [&:not(:first-child)]:font-digital "
                generalRowClassName="text-center [&:nth-child(1)]:bg-[#CBDB2A33] "
                generalColumnsClassName={`bg-[#F3F3F3] text-[13px] text-primary dark:text-white static text-left`}
                columnsData={columns}
                //@ts-ignore
                rowData={data?.data?.teams || []}
                config={config}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-2">
          {data?.data?.teams.map((group: any, index: number) => {
            const backgroundColor = `rgba(203,220,42, ${colorIndex / 100})`;
            if (colorIndex > 20) {
              colorIndex = colorIndex - 10;
            }

            return (
              <div className="px-4 mt-10">
                <div
                  style={{ backgroundColor: backgroundColor }}
                  className="text-center  py-3 mx-0.5  rounded-t-lg text-primary dark:text-white font-bold "
                >
                  <p>{Object?.keys(group)[0]}</p>
                </div>
                <div className="fixed-table  bg-transparent  ">
                  <Table
                    tableClassName="mt-0 rounded-t-none"
                    generalCellColumnClassName=""
                    tbodyClassName=" !bg-transparent rounded-none "
                    generalCellRowClassName="min-w-[150px] text-base overflow-hidden text-left  [&:not(:first-child)]:font-digital "
                    generalRowClassName="text-left [&:nth-child(1)]:bg-[#CBDB2A33] "
                    generalColumnsClassName={`bg-[#F3F3F3] text-[13px] text-primary dark:text-white static text-left`}
                    columnsData={columns}
                    //@ts-ignore
                    rowData={Object.values(group)[0] || []}
                    config={config}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Leaderboard;
